import EzController from 'controllers/ez-base-controller';
import Cookies from 'js-cookie';
import { scrolledIntoViewWithOffset } from 'lib/helpers';
import { isNoResultsPage } from 'lib/search-helpers';
import PartnerImageResults from 'components/partner/partner-image-results';
import { sendTrackingEvent } from 'components/analytics/conversions/tracking';
import { PARTNER_INFINITE_SCROLL_TRIGGERED, PARTNER_INFINITE_SCROLL_CLICK } from 'components/analytics/conversions/constants/actions';

export default class PartnerJustifiedSearchController extends EzController {
  static targets = [
    'apiResultsWrapper',
    'loadingAnim',
  ];

  static values = {
    contentType: String,
    terms: String,
    resultCount: Number,
  };

  connect() {
    this.loadingResults = false;

    sendTrackingEvent({
      element: this.element,
      data: {
        action: PARTNER_INFINITE_SCROLL_TRIGGERED,
        label: `Terms-${this.termsValue}`,
        value: this.resultCountValue,
        content_type: `Content-${this.contentTypeValue}`,
        non_interaction: true,
      },
    });

    this.searchTerm = this.apiResultsWrapperTarget.getAttribute('data-keyword');
    this.partnerServiceUrl = this.element.getAttribute('data-partner-service-url');

    this.partnerImages = new PartnerImageResults(
      this.apiResultsWrapperTarget,
      this.searchTerm,
      this.partnerServiceUrl,
    );

    this.sharedId = this.element.getAttribute('data-sharedid');
    this.subId1 = this.element.getAttribute('data-subid-one');
    this.subId2 = this.element.getAttribute('data-subid-two');

    const urlParams = this.partnerImages.makeUrlParams(
      this.sharedId,
      this.subId1,
      this.subId2,
      this.adType,
      this.adPlacement(),
    );

    this.partnerImageOptions = {
      page: 0,
      placement: this.placement(),
      controllerElem: this.element,
      affiliate: this.apiResultsWrapperTarget.getAttribute('data-affiliate'),
      impactRadiusUrl: this.apiResultsWrapperTarget.getAttribute('data-impact-radius-url'),
      loc: this.apiResultsWrapperTarget.getAttribute('data-loc'),
      limit: this.apiResultsWrapperTarget.getAttribute('data-limit'),
      apiparams: this.apiResultsWrapperTarget.getAttribute('data-apiparams'),
      rowHeight: parseInt(this.apiResultsWrapperTarget.getAttribute('data-row-height'), 10),
      maxRows: this.apiResultsWrapperTarget.getAttribute('data-max-rows'),
      largeThumb: true,
      padResults: false,
      urlparams: urlParams,
      padWithTerm: this.apiResultsWrapperTarget.getAttribute('data-pad-with-term'),
    };

    this.getPartnerImageResults();

    this.noResultTimer = setTimeout(() => {
      if (!this.element.querySelector('.ez-resource-thumb')) {
        this.element.parentNode.removeChild(this.element);
      }
    }, this.noResultsDelay);

    window.addEventListener('resultsLoaded', this.handleNewResults, { once: true });
    window.addEventListener('resultsLoaded', this.endLoadingResults);
  }

  disconnect() {
    window.removeEventListener('resultsLoaded', this.handleNewResults, { once: true });
    window.removeEventListener('resultsLoaded', this.endLoadingResults);
    window.removeEventListener('scroll', this.loadNextResults);
  }

  partnerClick = (event) => {
    const { index: itemIndex } = event.target.dataset;

    sendTrackingEvent({
      element: event.target,
      data: {
        action: PARTNER_INFINITE_SCROLL_CLICK,
        label: `Terms-${this.termsValue}`,
        value: parseInt(itemIndex, 10) + 1, // return 1 based index for GA
        content_type: `Content-${this.contentTypeValue}`,
      },
    });
  }

  handleNewResults = (event) => {
    if (event.detail !== 'END_OF_RESULTS') {
      window.clearTimeout(this.noResultTimer);
      window.addEventListener('scroll', this.loadNextResults);
    }
  }

  adPlacement() {
    let adPlacementSuffix = document.querySelector('body').dataset.istockAdplacementSuffix;
    if (adPlacementSuffix === undefined) {
      adPlacementSuffix = '';
    }
    return isNoResultsPage() ? `NRP${adPlacementSuffix}` : `SRP${adPlacementSuffix}`;
  }

  placement() {
    return isNoResultsPage() ? 'NoResults' : 'LastPage';
  }

  getPartnerImageResults() {
    this.loadingResults = true;

    this.addLoadingIndicator();

    this.partnerImages.getResults(this.partnerImageOptions);
  }

  endLoadingResults = (event) => {
    this.loadingResults = false;
    this.removeLoadingIndicator();

    if (event.detail === 'END_OF_RESULTS') window.removeEventListener('scroll', this.loadNextResults);
  }

  loadNextResults = () => {
    if (scrolledIntoViewWithOffset('.search-results', 800)) {
      const displayedCount = this.element.querySelectorAll('li').length;
      const totalCount = this.apiResultsWrapperTarget.getAttribute('data-total-count');

      if (this.loadingResults === false && displayedCount < totalCount) {
        this.partnerImageOptions.page += 1;

        this.getPartnerImageResults();
      }
    }
  }

  addLoadingIndicator() {
    this.loadingAnimTarget.classList.remove('is-hidden');
  }

  removeLoadingIndicator() {
    this.loadingAnimTarget.classList.add('is-hidden');
  }

  get noResultsDelay() {
    return 15 * 1000;
  }

  get adType() {
    return Cookies.get('content_type') || 'vector';
  }
}
